import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import moment from 'moment';
import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import { EmptyContent, Loading } from '../../components/common/commons.js';
import CurrencyInput from '../../components/currencyInput/CurrencyInput.js';
import { NavBar } from '../../components/navbar/index.js';
import { getCliente, getEstacionamento, getRevenda, getUsuario, isAdministrador } from '../../config/auth.js';
import { sendMessageByWhatsApp } from '../../managers/whatsApp/whatsapp.manager.js';
import { AlertSecondary, AlertSuccess } from '../../shared/alert-manager.js';
import { sendLogByUser } from '../../shared/analytics.js';
import { Collection } from '../../shared/constants.js';
import { cellphoneMask, copyLinkAndShare, dangerConfirm, documentMask, goToFirebase, goToNewWindow, goToWindow, goToWindowWithAlert, isNullOrEmpty, isValidDocument, normalizedField, queryString, reloadWithAlert, setPathWindow, successConfirm, takeIfIsNotNullOrEmpty, toastDismissLoading, toastError, toastLoading, toastSuccess, toastWarning, toCurrency, toStringFromDate, valueByMaximunChars } from '../../shared/utils.js';
import { getClientById } from '../../store/collections/clienteWorker.js';
import { addCompany, addCompanyCharge, getAllChargesByCompanyId, getAllCompaniesByClientId, getCompanyById, removeCompanyById, removeCompanyChargeById, updateCompanyById } from '../../store/collections/companyWorker.js';
import { getFormasPagamentosAtivasSemTags } from '../../store/collections/formaPagamentoWorker.js';
import { getAllParksByClientId } from '../../store/collections/parkWorker.js';
import { getAllConveniosOnlineByClientId, getAllConveniosOnlineByParkId } from '../../store/collections/relationshipWorker.js';
import { getTicketsByPartnerIdAndCompanyId } from '../../store/collections/ticketWorker.js';
import { TicketAnalyticsDialog } from '../buscas/ticketSearch.js';
import { CashierSelector } from '../cashier/components.js';
import { WhatsAppMessageListBody } from '../developer/messages/index.js';
import { UserPermissionButton } from '../operation/permission.js';
import { registerCompanyChargePayment } from './viewmodel/company.viewmodel.js';

class CompanyList extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (
            <NavBar>
                <CompanyListBody />
            </NavBar>
        )
    }
}

class CompanyDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isAdministrador: isAdministrador(),
            clienteId: getCliente()?.id,
            isEditing: false,
            key: queryString("tab") ?? "cobrancas",
            random: Math.random(),
            parks: [],
            state: "loading"
        }
        this.load()
    }

    load = async () => {
        this.setState({ state: "loading" })
        const company = await getCompanyById({ id: this.props.match.params.id })
        if (company?.clienteId === this.state.clienteId) {
            this.setState({ company: company })
            await this._loadParks()
            this.setState({ state: "fill" })
        } else {
            goToWindowWithAlert("/", "Empresa não encontrada.")
        }
    }

    _loadParks = async () => {
        const parks = await getAllParksByClientId({ clientId: this.state.clienteId })
        this.setState({ parks: parks })
    }

    saveCompanyData = async () => {
        if (!this.validateFields()) {
            return
        }
        const data = {
            name: this.state.name,
            document: normalizedField(this.state.document),
            representative: this.state.representative,
            cellphone: this.state.cellphone,
            email: this.state.email
        }
        this.setState({ isEditing: false })
        toastSuccess("Dados da empresa atualizados com sucesso!")
        await updateCompanyById({ id: this.state.company.id, data: data })
        sendLogByUser("Empresa", `Atualizou os dados da empresa ${this.state.company.name}`, {
            before: this.state.company,
            after: data
        })
    }

    editCompany = () => {
        this.setState({ isEditing: true })
        this.setState({
            name: this.state.company.name,
            document: this.state.company.document,
            representative: this.state.company.representative,
            cellphone: this.state.company.cellphone,
            email: this.state.company.email
        })
    }

    validateFields = () => {
        if (isNullOrEmpty(this.state.name)) {
            toastWarning("Preencha o nome da empresa.")
            return false
        }
        if (isNullOrEmpty(this.state.document)) {
            toastWarning("Preencha o CNPJ da empresa.")
            return false
        }
        if (isValidDocument(this.state.document) === false) {
            toastWarning("Preencha um CNPJ válido.")
            return false
        }
        if (isNullOrEmpty(this.state.representative)) {
            toastWarning("Preencha o nome do representante da empresa.")
            return false
        }
        if (isNullOrEmpty(this.state.cellphone)) {
            toastWarning("Preencha o celular da empresa.")
            return false
        }
        return true
    }

    showProfile = () => {
        const revenda = getRevenda();
        const url = `${revenda.siteTicket}/empresa/login/?id=${this.state.company.id}`
        goToNewWindow(url)
    }

    changeKey = (key) => {
        this.setState({ key: key })
        setPathWindow(`/visualizar/empresa/${this.state.company.id}?tab=${key}`)
    }

    hideChargeModal = () => {
        this.setState({ isShowingChargeModal: false })
    }

    showChargeModal = () => {
        this.setState({ isShowingChargeModal: true })
    }

    render() {
        return (
            <NavBar>
                {
                    this.state.state === "loading" && <Loading />
                }
                {
                    this.state.state === "fill" &&
                    <div className='row'>
                        <div className='col-lg-4'>
                            <div className="card mb-4">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    Detalhes da empresa
                                    <div className='btn-group'>
                                        {
                                            this.state.isEditing ?
                                                <>
                                                    <button onClick={(e) => this.setState({ isEditing: false })} className="btn btn-sm btn-secondary">
                                                        <i className="fas fa-edit mx-2" />
                                                        Cancelar
                                                    </button>
                                                    <button onClick={(e) => this.saveCompanyData()} className="btn btn-sm btn-success">
                                                        <i className="fas fa-save mx-2" />
                                                        Salvar alterações
                                                    </button>
                                                </> :
                                                <>
                                                    {
                                                        this.state.isAdministrador &&
                                                        <Tooltip title="Firebase" placement="top">
                                                            <button type="button" onClick={() => { goToFirebase({ collection: Collection.COMPANIES, id: this.state.company.id }) }} className="btn btn-warning btn-sm text-white">
                                                                <i className="fas fa-database" />
                                                            </button>
                                                        </Tooltip>
                                                    }
                                                    <UserPermissionButton className="btn btn-sm btn-secondary" permission="CREATE_COMPANY" action={this.editCompany}>
                                                        <i className="fas fa-edit mx-2" />
                                                        Editar dados
                                                    </UserPermissionButton>
                                                    <button onClick={(e) => this.showProfile()} className="btn btn-sm btn-success">
                                                        <i className="fas fa-external-link-square-alt mx-2" />
                                                        Perfil
                                                    </button>
                                                </>
                                        }
                                    </div>
                                </div>
                                {
                                    this.state.isEditing ?
                                        <div className='card-body'>
                                            <div className='row'>
                                                <div className="col-lg-6">
                                                    <label>Razão social</label>
                                                    <input type="text" value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} className="form-control" />
                                                </div>
                                                <div className="col-lg-6">
                                                    <label>CNPJ</label>
                                                    <NumberFormat className="form-control" mask='_' format={'##.###.###/####-##'} value={this.state.document} onChange={(e) => this.setState({ document: e.target.value })} />
                                                </div>
                                            </div>
                                            <div className='row mt-2'>
                                                <div className="col-lg-4">
                                                    <label>Representante</label>
                                                    <input type="text" value={this.state.representative} onChange={(e) => this.setState({ representative: e.target.value })} className="form-control" />
                                                </div>
                                                <div className="col-lg-4">
                                                    <label>Celular</label>
                                                    <NumberFormat className="form-control" mask='_' format={'(##)#####-####'} value={this.state.cellphone} onChange={(e) => this.setState({ cellphone: e.target.value })} />
                                                </div>
                                                <div className="col-lg-4">
                                                    <label>E-mail</label>
                                                    <input type="email" value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} className="form-control" />
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className='card-body'>
                                            <div className="col-lg-12">
                                                {
                                                    this.state.status === "inativo" ?
                                                        <div className='badge text-white text-bg-danger'>Inativo</div>
                                                        :
                                                        <div className='badge text-white text-bg-success'>Ativo</div>
                                                }
                                            </div>
                                            <div className="col-lg-12">
                                                <strong>Nome: </strong> {this.state.company?.name}
                                            </div>
                                            <div className="col-lg-12">
                                                <strong>Documento: </strong> {documentMask(this.state.company?.document)}
                                            </div>
                                            <div className="col-lg-12">
                                                <strong>Representante: </strong> {this.state.company?.representative}
                                            </div>
                                            <div className="col-lg-12">
                                                <strong>Celular: </strong> {cellphoneMask(this.state.company?.cellphone)}
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>
                        <div className='col-lg-8'>
                            <div className="card mb-4">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    Gerênciar empresa
                                    <div className='btn-group'>
                                        <button onClick={this.showChargeModal} className="btn btn-sm btn-success">
                                            <i className="fas fa-money-bill-wave-alt mx-2" />
                                            Gerar link de cobrança
                                        </button>
                                    </div>
                                </div>
                                <div className='card-body'>
                                    <Tabs key={this.state.random} className='profile-dropdown-toggle' defaultActiveKey={1} activeKey={this.state.key} onSelect={k => this.changeKey(k)}>
                                        <Tab eventKey="cobrancas" title="Cobranças">
                                            <CompanyChargesList company={this.state.company} />
                                        </Tab>
                                        <Tab eventKey="portal" title="Portal">
                                            <div className='mt-3'>
                                                <AlertSuccess tag="Novidade" message="Permita que seus parceiros comprem direto no portal." />
                                            </div>
                                            <CompanyPartnerList parks={this.state.parks} company={this.state.company} />
                                        </Tab>
                                        <Tab eventKey="consumo" title="Consumo">
                                            <CompanyQuantitiesList parks={this.state.parks} company={this.state.company} />
                                        </Tab>
                                        <Tab eventKey="historico" title="Histórico">
                                            <CompanyHistoryList parks={this.state.parks} company={this.state.company} />
                                        </Tab>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.isShowingChargeModal &&
                            <CompanyChargesGenerateModal
                                company={this.state.company}
                                parks={this.state.parks}
                                onClose={this.hideChargeModal}
                            />
                        }
                    </div>
                }
            </NavBar>
        )
    }
}

class CompanyChargesGenerateModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isAdministrador: isAdministrador(),
            clienteId: getCliente()?.id,
            estacionamentoId: getEstacionamento()?.id,
            company: props.company,
            items: [],
            items: [],
            parks: props.parks,
            isShowingChargeModal: false,
            partners: [],
            desconto: 0,
            state: "loading"
        }
        this.load()
    }

    load = async () => {
        this.setState({ state: "loading" })
        const company = await getCompanyById({ id: this.state.company.id })
        this.setState({ company: company })
        this.setState({ state: "fill" })
    }

    changePark = async (parkId) => {
        this.setState({ parkId: parkId }, this.reloadData)
    }

    changeTypeCharge = async (type) => {
        this.setState({ type: type }, this.reloadData)
    }

    reloadData = async () => {
        if (this.state.type === "partnership") {
            this.reloadPartnerships()
        }
    }

    reloadPartnerships = async () => {
        this.setState({
            stateBody: "loading",
            partners: []
        })
        const partners = await getAllConveniosOnlineByParkId({ estacionamentoId: this.state.parkId })
        if (!isNullOrEmpty(partners)) {
            this.setState({
                partners: partners.map(e => {
                    const park = this.state.parks.find(p => p.id === e.estacionamentoId)
                    return {
                        id: e.id,
                        name: e.nome,
                        parkName: park?.nome,
                        parkId: park?.id,
                        valorOnline: e.valorOnline,
                        quantity: 0,
                        quantidadeMaxima: e.quantidadeMaxima,
                        quantidadeMinima: e.quantidadeMinima,
                        multiplicador: e.multiplicador
                    }
                })
            })
            this.setState({ stateBody: "fill" })
        } else {
            this.setState({ stateBody: "empty" })
        }
    }

    showChargeModal = () => {
        this.setState({ isShowingChargeModal: true })
        this.setState({ itemsSelecteds: this.state.items.filter(e => e.checked === true) })
    }

    hideChargeModal = () => {
        this.setState({ isShowingChargeModal: false })
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    confirmChargeModal = async () => {
        if (!this.validateFields()) {
            return
        }
        toastLoading("Gerando cobrança...")
        var data = null
        switch (this.state.type) {
            case 'partnership':
                data = await this.confirmNewChargeByPartner()
                break;
        }
        if (this.state.sendChargeByWhatsApp && data) {
            await this.sendBillByWhatsApp(data)
        }
        toastDismissLoading()
        reloadWithAlert("Cobrança gerada com sucesso!")
    }

    sendBillByWhatsApp = async (item) => {
        const cellphone = this.state.company.cellphone
        if (isNullOrEmpty(cellphone)) {
            toastError("É preciso cadastrar o celular do representante da empresa para enviar mensagem via WhatsApp.")
            return
        }
        toastLoading("Registrando mensagem...")
        var client = await getClientById({ id: item.clienteId })
        const url = this.generateChargeLink(item)
        const message = `*${client.nome}*\n\nOlá ${this.state.company.representative}, acabamos de gerar um link de cobrança para a empresa:\n\n${this.state.company.name}\n\nVocê pode acessa-lo tocando abaixo:\n\n${url}`
        await sendMessageByWhatsApp({
            estacionamentoId: this.state.estacionamentoId,
            referenceId: item.id,
            phone: cellphone,
            message: message
        })
        toastDismissLoading()
        toastSuccess("Mensagem registrada para envio com sucesso.")
        sendLogByUser("Empresa", `Gerou um link enviando via WhatsApp para a empresa ${this.state.company.name}`, item)
    }

    generateChargeLink = (item) => {
        const revenda = getRevenda()
        return `${revenda.siteTicket}/empresa/login/?id=${item.companyId}&redirectTo=/empresa/cobranca/?id=${item.id}`
    }

    confirmNewChargeByPartner = async () => {
        var partners = this.state.partners.filter(e => e.quantity > 0)
        const data = {
            status: "pending",
            clienteId: this.state.clienteId,
            companyId: this.state.company.id,
            type: this.state.type,
            partners: partners,
            discount: this.state.desconto,
            originalTotal: this.state.total,
            quantity: partners.map(e => e.quantity).reduce((a, b) => a + b, 0),
            total: (this.state.total - this.state.desconto),
            generateNote: this.state.generateNoteModal
        }
        await addCompanyCharge({ data: data })
        return data
    }

    validateFields = () => {
        const partners = this.state.partners.filter(e => e.quantity > 0)
        for (const partner of partners) {
            if (partner.quantidadeMinima > partner.quantity) {
                toastWarning(`A quantidade mínima do convenio ${partner.name} é ${partner.quantidadeMinima}`)
                return false
            }
            if (partner.quantidadeMaxima < partner.quantity) {
                toastWarning(`A quantidade máxima do convenio ${partner.name} é ${partner.quantidadeMaxima}`)
                return false
            }
            if (partner.quantity % partner.multiplicador !== 0) {
                toastWarning(`O convenio ${partner.name} só pode ser comprado em múltiplos de ${partner.multiplicador}`)
                return false
            }
        }
        if (this.state.type === 'partnership') {
            if (isNullOrEmpty(this.state.total)) {
                toastWarning("Informe a quantidade de convênios.")
                return false
            }
        }
        return true
    }

    changeSelectedQuantity = (item, value) => {
        const quantity = parseInt(value)
        const index = this.state.partners.findIndex(e => e.id === item.id)
        this.state.partners[index].quantity = quantity
        this.setState({ partners: this.state.partners })
        var total = this.state.partners.map(e => (e.quantity ?? 0) * e.valorOnline).reduce((a, b) => a + b, 0)
        this.setState({ total: total }, this.atualizarValorTotal)
    }

    atualizarValorTotal = () => {
        const total = parseFloat(this.state.total)
        const desconto = parseFloat(this.state.desconto)
        this.setState({
            total: total,
            subTotal: (total - desconto)
        })
    }

    atualizarDesconto = (event, maskedvalue, floatvalue) => {
        if (floatvalue > this.state.total) {
            this.setState({ desconto: this.state.total }, this.atualizarValorTotal)
        } else {
            this.setState({ desconto: floatvalue }, this.atualizarValorTotal)
        }
    }

    render() {
        return (
            <Dialog onClose={this.hideChargeModal} maxWidth={'sm'} fullWidth open={true}>
                <MuiDialogTitle className='text-center'>
                    Gerar link de cobrança
                </MuiDialogTitle>
                <MuiDialogContent>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <strong>Estabelecimentos</strong>
                            <div className="input-group mb-3">
                                <select className="form-select" value={this.state.parkId} onChange={(e) => this.changePark(e.target.value)}>
                                    <option value=''>Selecionar</option>
                                    {
                                        this.state.parks.map((park, index) => <option key={index} value={park.id}>{takeIfIsNotNullOrEmpty(park.nomeInterno) ?? park.nome}</option>)
                                    }
                                </select>
                            </div>
                        </div>
                        {
                            !isNullOrEmpty(this.state.parkId) &&
                            <div className='col-lg-6'>
                                <strong>Tipo de cobrança</strong>
                                <div className="input-group mb-3">
                                    <select className="form-select" value={this.state.type} onChange={(e) => this.changeTypeCharge(e.target.value)}>
                                        <option value=''>Selecionar</option>
                                        <option value='partnership'>Convênio</option>
                                    </select>
                                </div>
                            </div>
                        }
                    </div>
                    {
                        this.state.stateBody == "loading" ?
                            <Loading /> : <>
                                {
                                    this.state.type === 'partnership' && <>
                                        <div className='row'>
                                            {
                                                isNullOrEmpty(this.state.partners) ?
                                                    <EmptyContent text='Nenhum convênio encontrado.' />
                                                    :
                                                    <>
                                                        <div className='table-responsive'>
                                                            <table className="table table-striped">
                                                                <tr>
                                                                    <td><strong>Nome</strong></td>
                                                                    <td align='center'><strong>Valor unitário</strong></td>
                                                                    <td width={20}><strong>Quantidade</strong></td>
                                                                </tr>
                                                                <tbody>
                                                                    {
                                                                        this.state.partners?.map(item =>
                                                                            <tr key={item.id}>
                                                                                <td>{item.name}</td>
                                                                                <td align='center'>{toCurrency(item.valorOnline)}</td>
                                                                                <td>
                                                                                    <input type="number" className='form-control' value={item.quantity} onChange={(e) => this.changeSelectedQuantity(item, e.target.value)} />
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <div className="col-lg-5">
                                                                <label>Desconto</label>
                                                                <CurrencyInput value={this.state.desconto} prefix="R$" className='form-control' onChangeEvent={this.atualizarDesconto} />
                                                            </div>
                                                            <div className="col-lg-12 mt-3">
                                                                {
                                                                    isNullOrEmpty(this.state.desconto) ?
                                                                        <div className='text-end'>
                                                                            <h5>Total</h5>
                                                                            <h3 className='text-success'>{toCurrency(this.state.total)}</h3>
                                                                        </div> :
                                                                        <div className='row text-end'>
                                                                            <strong>Desconto</strong><br />
                                                                            <h6 className='text-warning'>-{toCurrency(this.state.desconto)}</h6>
                                                                            <strong>Total</strong>
                                                                            <h3 className='text-success'>{toCurrency(this.state.total - this.state.desconto)}</h3>
                                                                        </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </>
                                            }
                                        </div>
                                    </>
                                }
                            </>
                    }
                    <div className="form-check form-switch my-2">
                        <input className="form-check-input" id="sendChargeByWhatsApp" checked={this.state.sendChargeByWhatsApp} onChange={(e) => this.setState({ sendChargeByWhatsApp: e.target.checked })} type="checkbox" />
                        <label className="form-check-label" htmlFor="sendChargeByWhatsApp">
                            Enviar link da cobrança via WhatsApp
                        </label>
                    </div>
                    <div className="form-check form-switch my-2">
                        <input className="form-check-input" id="generateNoteModal" checked={this.state.generateNoteModal} onChange={(e) => this.setState({ generateNoteModal: e.target.checked })} type="checkbox" />
                        <label className="form-check-label" htmlFor="generateNoteModal">
                            Gerar nota fiscal após o pagamento
                        </label>
                    </div>
                </MuiDialogContent>
                <MuiDialogActions>
                    <div className="btn-group m-3">
                        <button onClick={this.hideChargeModal} className='btn btn-secondary'>Fechar</button>
                        <button onClick={this.confirmChargeModal} className='btn btn-success'>Confirmar</button>
                    </div>
                </MuiDialogActions>
            </Dialog>
        )
    }
}

class CompanyPartnerList extends React.Component {

    constructor(props) {
        super(props);
        const company = props.company
        this.state = {
            isAdministrador: isAdministrador(),
            clienteId: getCliente()?.id,
            company: company,
            partnersBuyEnabled: company.partnersBuyEnabled,
            generateNote: company.generateNote,
            items: [],
            parks: props.parks,
            items: [],
            isShowingChargeModal: false,
            desconto: 0,
            state: "loading"
        }
        this.load()
    }

    load = async () => {
        this.setState({ state: "loading" })
        const items = await getAllConveniosOnlineByClientId({ clienteId: this.state.clienteId })
        if (!isNullOrEmpty(items)) {
            const partnerSelecteds = this.state.company?.partnersAlloweds ?? []
            this.setState({
                items: items.map(e => {
                    const park = this.state.parks.find(p => p.id === e.estacionamentoId)
                    return {
                        ...e,
                        checked: partnerSelecteds.find(p => p.id === e.id) != undefined,
                        parkName: takeIfIsNotNullOrEmpty(park.nomeInterno) ?? park.nome ?? "-",
                        parkId: park.id,
                    }
                })
            })
            this.setState({ state: "fill" })
        } else {
            this.setState({ state: "empty" })
        }
    }

    checkPartner = (item, checked) => {
        item.checked = checked
        this.setState({ items: this.state.items })
    }

    savePartners = async () => {
        const partners = this.state.items.filter(e => e.checked === true).map(e => {
            return {
                id: e.id,
                name: e.nome,
                parkName: e.parkName,
                parkId: e.parkId,
                multiplier: e.multiplicador,
                maxQuantity: e.quantidadeMaxima,
                minQuantity: e.quantidadeMinima,
                price: e.valorOnline
            }
        })
        toastLoading("Salvando...")
        var company = {
            ...this.state.company,
            partnersAlloweds: partners,
            partnersBuyEnabled: this.state.partnersBuyEnabled,
            generateNote: this.state.generateNote
        }
        await updateCompanyById({ id: company.id, data: company })
        toastDismissLoading()
        toastSuccess("Convênios atribuídos com sucesso!")
    }

    render() {
        return (
            <div className='row'>
                <div className='col-lg-12'>
                    {
                        this.state.state === "loading" && <Loading />
                    }
                    {
                        this.state.state === "empty" && <div className='text-center'>
                            <EmptyContent text='Nenhum convênio online cadastrado.' />
                            <a href='/cadastrar/convenio' className='btn btn-success mb-4'>
                                <i className="fa-solid fa-wand-magic-sparkles mx-2" />
                                Cadastrar convênio
                            </a>
                        </div>
                    }
                    {
                        this.state.state === "fill" && <>
                            <AlertSecondary tag="Convênios online">
                                Defina quais convênios a empresa terá permissão para fazer compras online.
                                <div className="form-check form-switch">
                                    <input className="form-check-input" id="partnersBuyEnabled" checked={this.state.partnersBuyEnabled} onChange={(e) => this.setState({ partnersBuyEnabled: e.target.checked })} type="checkbox" />
                                    <label className="form-check-label" htmlFor="partnersBuyEnabled">
                                        Habilitar função de compra online de convênios
                                    </label>
                                </div>
                            </AlertSecondary>
                            {
                                this.state.partnersBuyEnabled &&
                                <div className='table-responsive'>
                                    <table className="table table-striped">
                                        <tr>
                                            <td width={10} />
                                            <td><strong>Estabelecimento</strong></td>
                                            <td><strong>Convênio</strong></td>
                                            <td align='center'><strong>Valor unitario</strong></td>
                                            <td className="d-none d-sm-table-cell" align='center'><strong>Min | Max</strong></td>
                                            <td className="d-none d-sm-table-cell" align='center'><strong>Multiplicador</strong></td>
                                        </tr>
                                        <tbody>
                                            {
                                                this.state.items.map(item =>
                                                    <tr key={item.id}>
                                                        <td width={10}>
                                                            <div className="form-check form-switch">
                                                                <input className="form-check-input" id="fecharCaixaParcial" checked={item.checked} onChange={(e) => this.checkPartner(item, e.target.checked)} type="checkbox" />
                                                            </div>
                                                        </td>
                                                        <td>{item.parkName}</td>
                                                        <td>{item.nome}</td>
                                                        <td align='center'>{toCurrency(item.valorOnline)}</td>
                                                        <td className="d-none d-sm-table-cell" align='center'>{item.quantidadeMinima} | {item.quantidadeMaxima}</td>
                                                        <td className="d-none d-sm-table-cell" align='center'>{item.multiplicador}</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            }
                            <div className="form-check form-switch">
                                <input className="form-check-input" id="generateNote" checked={this.state.generateNote} onChange={(e) => this.setState({ generateNote: e.target.checked })} type="checkbox" />
                                <label className="form-check-label" htmlFor="generateNote">
                                    Emitir nota fiscal para todos os pagamentos.
                                </label>
                            </div>
                            <div className='btn-group mt-2'>
                                <button type="button" onClick={this.savePartners} className="btn btn-primary">
                                    Salvar configurações
                                </button>
                            </div>
                        </>
                    }
                </div>
            </div>
        )
    }
}

class CompanyChargesList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isAdministrador: isAdministrador(),
            estacionamentoId: getEstacionamento()?.id,
            company: props.company,
            generateNote: false,
            paymentDate: moment(new Date()),
            chargeId: queryString("chargeId"),
            items: [],
            state: "loading"
        }
        this.load()
    }

    load = async () => {
        this.setState({ state: "loading" })
        const items = await getAllChargesByCompanyId({ companyId: this.state.company.id })
        if (!isNullOrEmpty(items)) {
            this.setState({ items: items.sort((a, b) => a.createdAt.toDate() - b.createdAt.toDate()) })
            const charge = items.find(e => e.id === this.state.chargeId)
            if (charge) {
                this.showChargeModal(charge)
            }
            this.setState({ state: "fill" })
        } else {
            this.setState({ state: "empty" })
        }
    }

    removeCharge = async (item) => {
        if (item.status === "pending") {
            var confirm = await dangerConfirm({ message: `Deseja mesmo remover esta cobrança?` });
            if (confirm) {
                const items = this.state.items.filter(e => e.id !== item.id)
                this.setState({ items: items })
                if (isNullOrEmpty(items)) {
                    this.setState({ state: "empty" })
                }
                await removeCompanyChargeById({ id: item.id })
            }
        } else {
            toastWarning("Não é possível remover uma cobrança que já foi paga.")
        }
    }

    showMessagesSent = async (item) => {
        this.setState({ referenceId: item.id })
        this.setState({ showWhatsAppMessagesModal: true })
    }

    hideWhatsAppMessages = () => {
        this.setState({ showWhatsAppMessagesModal: false })
    }

    copyChargeLink = (item) => {
        const url = this.generateChargeLink(item)
        copyLinkAndShare({
            title: item.clienteNome,
            message: "Cobrança da mensalidade",
            url: url,
        })
        const message = `Tocou em copiar link em uma cobrança do mensalista ${item.clienteNome} : ${item.id}.`
        sendLogByUser("Detalhes Mensalistas", message)
    }

    sendBillByWhatsApp = async (item) => {
        const cellphone = this.state.company.cellphone
        if (isNullOrEmpty(cellphone)) {
            toastError("É preciso cadastrar o celular do representante da empresa para enviar mensagem via WhatsApp.")
            return
        }
        var confirm = await successConfirm({ message: `Deseja mesmo enviar uma mensagem com o link de cobrança para esta empresa?` })
        if (confirm) {
            toastLoading("Registrando mensagem...")
            var client = await getClientById({ id: item.clienteId })
            const url = this.generateChargeLink(item)
            const message = `*${client.nome}*\n\nOlá ${this.state.company.representative}, acabamos de gerar um link de cobrança para a empresa:\n\n${this.state.company.name}\n\nVocê pode acessa-lo tocando abaixo:\n\n${url}`
            await sendMessageByWhatsApp({
                estacionamentoId: this.state.estacionamentoId,
                referenceId: item.id,
                phone: cellphone,
                message: message
            })
            toastDismissLoading()
            toastSuccess("Mensagem registrada para envio com sucesso.")
            sendLogByUser("Empresa", `Tocou em enviar link via WhatsApp em uma cobrança para a empresa ${this.state.company.name}`, item)
        }
    }

    generateChargeLink = (item) => {
        const revenda = getRevenda()
        return `${revenda.siteTicket}/empresa/login/?id=${item.companyId}&redirectTo=/empresa/cobranca/?id=${item.id}`
    }

    showChargeModal = (item) => {
        this.setState({ chargeSelected: item })
        this.setState({ isShowingChargeModal: true })
    }

    hideChargeModal = () => {
        this.setState({ isShowingChargeModal: false })
    }

    showRegisterPaymentModal = async (item) => {
        toastLoading("Aguarde...")
        const formasPagamentos = await getFormasPagamentosAtivasSemTags({ estacionamentoId: item.estacionamentoId })
        this.setState({ formasPagamentos: formasPagamentos })
        this.setState({ chargeSelected: item })
        this.setState({ isShowingRegisterPaymentModal: true })
        toastDismissLoading()
    }

    handleBaixaDateChange = (newValue) => {
        this.setState({ paymentDate: newValue })
    }

    onChangeNewNoteForm = (data) => {
        this.setState({ note: data })
    }

    hideRegisterPaymentModal = () => {
        this.setState({ isShowingRegisterPaymentModal: false })
    }

    onSelectedCashier = (cashier) => {
        this.setState({ cashier: cashier })
    }

    confirmRegisterPaymentModal = async () => {
        if (isNullOrEmpty(this.state.cashier)) {
            toastWarning("É necessário selecionar um caixa.")
            return
        }
        const paymentMethod = this.state.formasPagamentos.find(e => e.id === this.state.formaDePagamentoSelecionadaId)
        if (isNullOrEmpty(paymentMethod)) {
            toastWarning("É necessário selecionar um método de pagamento.")
            return
        }
        toastLoading("Registrando pagamento...")
        this.hideRegisterPaymentModal()
        const charge = this.state.chargeSelected
        if (this.state.generateNote) {
            charge.newNote = {
                document: this.state.company.document,
                name: this.state.company.document
            }
        }
        const result = await registerCompanyChargePayment({
            charge: charge,
            cashier: this.state.cashier,
            paymentMethod: paymentMethod,
            paymentDate: this.state.paymentDate.toDate(),
            generateNote: this.state.generateNote
        })
        if (result.success) {
            reloadWithAlert("Cobrança registrada com sucesso!")
        } else {
            toastError(result.message)
        }
    }

    render() {
        return (
            <div className='row'>
                <div className='col-lg-12'>
                    {
                        this.state.state === "loading" && <Loading />
                    }
                    {
                        this.state.state === "empty" && <EmptyContent text='Nenhuma cobrança gerada até o momento.' />
                    }
                    {
                        this.state.state === "fill" && <div className='mt-3'>
                            <table className='table table-responsive table-striped'>
                                <tr>
                                    {
                                        this.state.isAdministrador &&
                                        <td width={10} />
                                    }
                                    <td width={10} />
                                    <td width={10}><strong>Status</strong></td>
                                    <td width={10}><strong>Tipo</strong></td>
                                    <td align='center'><strong>Data da criação</strong></td>
                                    <td align='center'><strong>Valor</strong></td>
                                    <td width={10} align='right' />
                                </tr>
                                <tbody>
                                    {
                                        this.state.items.map(item =>
                                            <tr key={item.id}>
                                                {
                                                    this.state.isAdministrador &&
                                                    <td width={10}>
                                                        <div className="btn-group">
                                                            <Tooltip title="Firebase" placement="top">
                                                                <button type="button" onClick={() => { goToFirebase({ collection: Collection.COMPANIES_CHARGES, id: item.id }) }} className="btn btn-warning text-white">
                                                                    <i className="fas fa-database" />
                                                                </button>
                                                            </Tooltip>
                                                        </div>
                                                    </td>
                                                }
                                                <td align='left'>
                                                    <div className='btn-group'>
                                                        <Tooltip title="Mensagens enviadas" placement="top">
                                                            <button type="button" onClick={() => { this.showMessagesSent(item) }} className="btn btn-success">
                                                                <i className="fas fa-comments" />
                                                            </button>
                                                        </Tooltip>
                                                        {
                                                            item.status === "pending" &&
                                                            <>
                                                                <Tooltip title="Copiar link da cobrança" placement="top">
                                                                    <button onClick={(e) => this.copyChargeLink(item)} className="btn btn-success text-white">
                                                                        <i className="fas fa-share-alt" />
                                                                    </button>
                                                                </Tooltip>
                                                                <Tooltip title="Enviar no WhatsApp" placement="top">
                                                                    <button type="button" onClick={() => { this.sendBillByWhatsApp(item) }} className="btn btn-success">
                                                                        <i className="fa-brands fa-whatsapp" />
                                                                    </button>
                                                                </Tooltip>
                                                            </>
                                                        }
                                                    </div>
                                                </td>
                                                <td>
                                                    {
                                                        item.status === "pending" &&
                                                        <span className="badge text-bg-warning text-white mt-2">Pendente</span>
                                                    }
                                                    {
                                                        item.status === "paid" &&
                                                        <span className="badge text-bg-success mt-2">Pago</span>
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        item.type === "partnership" &&
                                                        <span className="badge text-bg-success mt-2">Convênio</span>
                                                    }
                                                </td>
                                                <td align='center'>
                                                    {toStringFromDate({ date: item.createdAt, format: "DD/MM/YYYY [às] HH:mm" })}
                                                </td>
                                                <td align='center'>{toCurrency(item.total)}</td>
                                                <td width={10} align='right'>
                                                    <div className="btn-group">
                                                        {
                                                            item.cashier &&
                                                            <Tooltip title="Ver caixa" placement="top">
                                                                <a type="button" href={`/caixas/${item.cashier.id}`} target='_blank' className="btn btn-primary text-white">
                                                                    <i className="fas fa-eye" />
                                                                </a>
                                                            </Tooltip>
                                                        }
                                                        {
                                                            item.status === "pending" &&
                                                            <Tooltip title="Registrar pagamento" placement="top">
                                                                <button type="button" onClick={(e) => this.showRegisterPaymentModal(item)} className="btn btn-success text-white">
                                                                    <i className="fas fa-sack-dollar" />
                                                                </button>
                                                            </Tooltip>
                                                        }
                                                        <Tooltip title="Detalhes" placement="top">
                                                            <button type="button" onClick={(e) => this.showChargeModal(item)} className="btn btn-secondary text-white">
                                                                <i className="fa-solid fa-list" />
                                                            </button>
                                                        </Tooltip>
                                                        <Tooltip title="Remover" placement="top">
                                                            <button type="button" onClick={(e) => this.removeCharge(item)} className="btn btn-danger">
                                                                <i className="fas fa-trash" />
                                                            </button>
                                                        </Tooltip>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    }
                    <Dialog fullWidth maxWidth="lg" onClose={this.hideWhatsAppMessages} open={this.state.showWhatsAppMessagesModal}>
                        <MuiDialogContent>
                            <WhatsAppMessageListBody referenceId={this.state.referenceId} />
                        </MuiDialogContent>
                        <MuiDialogActions>
                            <button onClick={this.hideWhatsAppMessages} className='btn btn-secondary m-3'>Fechar</button>
                        </MuiDialogActions>
                    </Dialog>
                    <Dialog fullWidth maxWidth="sm" onClose={this.hideChargeModal} open={this.state.isShowingChargeModal}>
                        <MuiDialogTitle className='text-center'>
                            Detalhes da cobrança
                        </MuiDialogTitle>
                        <MuiDialogContent>
                            {
                                this.state.chargeSelected?.status === "PAID" &&
                                <span className="badge text-bg-success">Pago</span>
                            }
                            {
                                this.state.chargeSelected?.type === "partnership" &&
                                <>
                                    <span className="badge text-bg-success">Convênio</span>
                                    <div className='row mt-2'>
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <td><strong>Estabelecimento</strong></td>
                                                    <td><strong>Nome</strong></td>
                                                    <td align='right'><strong>Quantidade</strong></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.chargeSelected?.partners?.map(item =>
                                                        <tr key={item.id}>
                                                            <td>{item.parkName}</td>
                                                            <td>{item.name}</td>
                                                            <td align='right'>{item.quantity}</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            }
                            <div className='row mt-2'>
                                <label>Valor</label><br />
                                <strong>{toCurrency(this.state.chargeSelected?.total)}</strong>
                            </div>
                            <div className='row'>
                                <label>Data da criação</label><br />
                                <strong>{toStringFromDate({ date: this.state.chargeSelected?.createdAt, format: "DD/MM/YYYY [às] HH:mm" })}</strong>
                            </div>
                        </MuiDialogContent>
                        <MuiDialogActions>
                            <div className='btn-group m-3'>
                                <button onClick={this.hideChargeModal} className='btn btn-secondary'>Fechar</button>
                            </div>
                        </MuiDialogActions>
                    </Dialog>
                    <Dialog onClose={this.hideRegisterPaymentModal} maxWidth={'sm'} open={this.state.isShowingRegisterPaymentModal}>
                        <MuiDialogTitle className='text-center'>
                            Pagamento da cobrança
                        </MuiDialogTitle>
                        <MuiDialogContent>
                            <div className="col-lg-12">
                                <div className="alert alert-secondary">
                                    <strong>Usuário que esta fazendo o pagamento</strong> <br />
                                    <strong>Nome: </strong><span>{getUsuario()?.nome}</span> <br />
                                    <strong>Data e hora: </strong><span>{moment(new Date()).format("DD/MM/YYYY [às] HH:mm")}</span> <br />
                                </div>
                                <CashierSelector title="Fazer lançamento no caixa:" onSelectedCashier={this.onSelectedCashier} />
                            </div>
                            {
                                this.state.chargeSelected?.type === "partnership" &&
                                <>
                                    <span className="badge text-bg-success">Convênio</span>
                                    <div className='mt-2'>
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <td><strong>Estabelecimento</strong></td>
                                                    <td><strong>Nome</strong></td>
                                                    <td align='right'><strong>Quantidade</strong></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.chargeSelected?.partners?.map(item =>
                                                        <tr key={item.id}>
                                                            <td>{item.parkName}</td>
                                                            <td>{item.name}</td>
                                                            <td align='right'>{item.quantity}</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            }
                            <div className='row mt-2'>
                                <div className="col-lg-6">
                                    <strong>Valor</strong><br />
                                    <label>{toCurrency(this.state.chargeSelected?.total)}</label>
                                </div>
                                <div className="col-lg-6">
                                    <strong>Data da criação</strong><br />
                                    <label>{toStringFromDate({ date: this.state.chargeSelected?.createdAt, format: "DD/MM/YYYY [às] HH:mm" })}</label>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-lg-6">
                                    <strong>Data do pagamento: </strong> <br />
                                    <MobileDatePicker
                                        label="-"
                                        inputFormat="DD/MM/yyyy"
                                        value={this.state.paymentDate}
                                        onChange={this.handleBaixaDateChange}
                                        renderInput={(params) => <TextField {...params} size="small" className='form-control' />}
                                    />
                                </div>
                                <div className="col-lg-6">
                                    <strong>Forma de pagamento: </strong>
                                    <select className='form-select' value={this.state.formaDePagamentoSelecionadaId} onChange={(e) => this.setState({ formaDePagamentoSelecionadaId: e.target.value })}>
                                        <option value=''>Selecione</option>
                                        {
                                            this.state.formasPagamentos?.map(item => { return <option value={item.id}>{item.nome === item.tipo ? item.nome : `${item.tipo} - ${item.nome}`}</option> })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="form-check form-switch mt-2">
                                <input className="form-check-input" id="generateNotePayment" checked={this.state.generateNote} onChange={(e) => this.setState({ generateNote: e.target.checked })} type="checkbox" />
                                <label className="form-check-label" htmlFor="generateNotePayment">
                                    Gerar nota fiscal
                                </label>
                            </div>
                        </MuiDialogContent>
                        <MuiDialogActions>
                            <div className="btn-group m-3">
                                <button onClick={this.hideRegisterPaymentModal} className='btn btn-secondary'>Fechar</button>
                                <button onClick={this.confirmRegisterPaymentModal} className='btn btn-success'>Confirmar pagamento</button>
                            </div>
                        </MuiDialogActions>
                    </Dialog>
                </div>
            </div>
        )
    }
}

class CompanyQuantitiesList extends React.Component {

    constructor(props) {
        super(props);
        const partners = props.company?.partners ?? []
        this.state = {
            isAdministrador: isAdministrador(),
            estacionamentoId: getEstacionamento()?.id,
            company: props.company,
            parks: props.parks,
            state: partners.length > 0 ? "fill" : "empty",
            items: partners
        }
    }

    onShowPartnerHistory = async (item) => {
        toastLoading("Buscando histórico de uso...")
        const companyId = this.state.company.id
        const tickets = await getTicketsByPartnerIdAndCompanyId({ partnerId: item.id, companyId: companyId })
        toastDismissLoading()
        this.setState({ tickets: tickets })
        this.setState({ showModalPartnerHistory: true })
    }

    onClosePartnerHistory = () => {
        this.setState({ showModalPartnerHistory: false })
    }

    render() {
        return (
            <div className='row'>
                <div className='col-lg-12'>
                    {
                        this.state.state === "empty" && <EmptyContent text='Nenhum consumo registrado.' />
                    }
                    {
                        this.state.state === "fill" &&
                        <div className='mt-3'>
                            <AlertSecondary tag="Convênios" />
                            <table className='table table-responsive table-striped'>
                                <tr>
                                    <td><strong>Nome</strong></td>
                                    <td align='center'><strong>Quantidade disponível</strong></td>
                                    <td width={10} />
                                </tr>
                                <tbody>
                                    {
                                        this.state.items.map(item =>
                                            <tr key={item.id}>
                                                <td>{item.name}</td>
                                                <td align='center'>{item.quantity}</td>
                                                <td>
                                                    <div className="btn-group">
                                                        <Tooltip title="Histórico de uso" placement="top">
                                                            <button className='btn btn-warning text-white' onClick={(e) => this.onShowPartnerHistory(item)}>
                                                                <QueryStatsIcon />
                                                            </button>
                                                        </Tooltip>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
                {
                    this.state.showModalPartnerHistory && <TicketAnalyticsDialog tickets={this.state.tickets} onClose={this.onClosePartnerHistory} />
                }
            </div>
        )
    }
}

class CompanyHistoryList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isAdministrador: isAdministrador(),
            id: queryString("id"),
            clienteId: getCliente()?.id,
            revendaId: getEstacionamento()?.revendaId,
            random: Math.random(),
            company: props.company,
            items: props.company.logs ?? [],
            state: props.company.logs?.length > 0 ? "fill" : "empty",
            parks: props.parks
        }
    }

    render() {
        return (
            <div className='row'>
                <div className='col-lg-12'>
                    {
                        this.state.state === "empty" && <EmptyContent text='Nenhum histórico registrado.' />
                    }
                    {
                        this.state.state === "fill" &&
                        <div className='mt-3'>
                            <table className='table table-responsive table-striped'>
                                <tr>
                                    <td><strong>Data</strong></td>
                                    <td><strong>Operador</strong></td>
                                    <td><strong>Mudança</strong></td>
                                    <td width={10} />
                                </tr>
                                <tbody>
                                    {
                                        this.state.items.map(item =>
                                            <tr key={item.id}>
                                                <td>{toStringFromDate({ date: item.createdAt, format: "DD/MM/YYYY [às] HH:mm" })}</td>
                                                <td>{item.createdBy.nome}</td>
                                                <td>{item.message}</td>
                                                <td align='right' width={10}>
                                                    {
                                                        !isNullOrEmpty(item.ticketId) &&
                                                        <div className='btn-group'>
                                                            <Tooltip title="Ver ticket" placement="top">
                                                                <a href={`/buscar/ticket?id=${item.ticketId}`} target='_blank' className="btn btn-warning text-white">
                                                                    <i className="fas fa-ticket-alt" />
                                                                </a>
                                                            </Tooltip>
                                                        </div>
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

class CompanyListBody extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isAdministrador: isAdministrador(),
            id: queryString("id"),
            clienteId: getCliente()?.id,
            revendaId: getEstacionamento()?.revendaId,
            random: Math.random(),
            key: "convenios",
            state: "loading"
        }
    }

    componentDidMount = async () => {
        await this.load(true)
    }

    load = async () => {
        this.setState({ state: "loading" })
        const items = await getAllCompaniesByClientId({
            clienteId: this.state.clienteId
        })
        if (isNullOrEmpty(items)) {
            this.setState({ state: "empty" })
        } else {
            this.setState({
                items: items,
                auxItems: items,
                state: "fill"
            })
        }
    }

    onEdit = async (item) => {
        this.setState({ ...item })
        this.setState({ id: item.id })
    }

    onDuplicate = (item) => {
        item.id = null
        this.onEdit(item)
    }

    onRemove = async (item) => {
        var confirm = await dangerConfirm({ message: `Confirma mesmo desativar esta empresa?` })
        if (confirm) {
            toastLoading("Desativando empresa...")
            await removeCompanyById({ id: item.id })
            await this.load()
            toastDismissLoading()
            toastSuccess("Desativando empresa com sucesso.")
        }
    }

    showDetail = (item) => {
        goToWindow("/visualizar/empresa/" + item.id)
    }

    copyCompanyProfile = (item) => {
        const revenda = getRevenda()
        const url = `${revenda.siteTicket}/empresa/visualizar/?id=${item.id}`
        copyLinkAndShare({
            title: item.name,
            message: "Empresa",
            url: url,
        })
        const message = `Tocou em copiar link empresa ${item.name}.`
        sendLogByUser("Reservas", message)
    }

    search = (e) => {
        const value = e.target.value.toUpperCase().replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").replaceAll("(", "").replaceAll(")", "").replaceAll("-", "")
        if (value === "") {
            this.setState({ state: "fill" })
            this.setState({ items: this.state.auxItems })
        } else {
            const result = this.state.auxItems.filter(e =>
                e.name.toUpperCase().includes(value) ||
                e.document.toUpperCase().includes(value) ||
                e.cellphone.toUpperCase().includes(value)
            )
            if (isNullOrEmpty(result)) {
                this.setState({ state: "empty-search" })
            } else {
                this.setState({ state: "fill" })
                this.setState({ items: result })
            }
        }
    }

    showNewCompanyModal = () => {
        this.setState({ isShowingNewCompanyModal: true })
    }

    confirmNewCompany = async () => {
        if (!this.validateFields()) {
            return
        }
        this.setState({ isShowingNewCompanyModal: false })
        toastLoading("Cadastrando...")
        const data = {
            revendaId: this.state.revendaId,
            clienteId: this.state.clienteId,
            name: this.state.name,
            document: normalizedField(this.state.document),
            representative: this.state.representative,
            cellphone: this.state.cellphone,
            email: this.state.email
        }
        await addCompany({ data: data })
        toastDismissLoading()
        toastSuccess("Empresa cadastrada com sucesso.")
        goToWindow(`/visualizar/empresa/${data.id}`)
    }

    validateFields = () => {
        if (isNullOrEmpty(this.state.name)) {
            toastWarning("Preencha o nome da empresa.")
            return false
        }
        if (isNullOrEmpty(this.state.document)) {
            toastWarning("Preencha o CNPJ da empresa.")
            return false
        }
        if (isValidDocument(this.state.document) === false) {
            toastWarning("Preencha um CNPJ válido.")
            return false
        }
        if (isNullOrEmpty(this.state.representative)) {
            toastWarning("Preencha o nome do representante da empresa.")
            return false
        }
        if (isNullOrEmpty(this.state.cellphone)) {
            toastWarning("Preencha o celular da empresa.")
            return false
        }
        return true
    }

    hideNewCompanyModal = () => {
        this.setState({ isShowingNewCompanyModal: false })
    }

    render() {
        return (
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    Empresas
                    <div className='btn-group'>
                        <UserPermissionButton className="btn btn-sm btn-primary" permission="CREATE_COMPANY" action={this.showNewCompanyModal}>
                            <i className="fas fa-plus mx-2" />
                            Cadastrar
                        </UserPermissionButton>
                    </div>
                </div>
                <div className="mb-4">
                    {
                        this.state.state === "fill" || this.state.state === "empty-search" &&
                        <div className='card-body'>
                            <div className='col-lg-12'>
                                <input type="text" onChange={this.search} placeholder="Faça uma busca por nome, celular, documento..." className="form-control" />
                            </div>
                        </div>
                    }
                    {
                        this.state.state === "loading" &&
                        <Loading />
                    }
                    {
                        this.state.state === "empty" &&
                        <EmptyContent text='Nenhuma empresa cadastrada.' />
                    }
                    {
                        this.state.state === "empty-search" &&
                        <EmptyContent text='Nenhuma empresa encontrada com este filtro.' />
                    }
                    {
                        this.state.state === "fill" &&
                        <div>
                            <div className='col-md-12'>
                                <div className='table-responsive'>
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                {
                                                    this.state.isAdministrador &&
                                                    <td width={10} />
                                                }
                                                <td width={10} />
                                                <td align='left'><strong>Razão social</strong></td>
                                                <td align='center'><strong>Documento</strong></td>
                                                <td align='left'><strong>Representante</strong></td>
                                                <td align='center'><strong>Celular</strong></td>
                                                <td width={10} />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.items?.map((item, index) =>
                                                    <tr key={index} className='align-middle'>
                                                        {
                                                            this.state.isAdministrador &&
                                                            <td className="d-none d-sm-table-cell">
                                                                <div className='btn-group'>
                                                                    <Tooltip title="Firebase" placement="top">
                                                                        <button type="button" onClick={() => { goToFirebase({ collection: Collection.COMPANIES, id: item.id }) }} className="btn btn-warning text-white">
                                                                            <i className="fas fa-database" />
                                                                        </button>
                                                                    </Tooltip>
                                                                </div>
                                                            </td>
                                                        }
                                                        <td align='left'>
                                                            <div className='btn-group'>
                                                                <Tooltip title="Copiar link" placement="top">
                                                                    <button onClick={(e) => this.copyCompanyProfile(item)} className="btn btn-success text-white">
                                                                        <i className="fas fa-share-alt" />
                                                                    </button>
                                                                </Tooltip>
                                                            </div>
                                                        </td>
                                                        <td align='left'>{valueByMaximunChars(item.name, 30)}</td>
                                                        <td align='center'>{documentMask(item.document)}</td>
                                                        <td align='left'>{item.representative}</td>
                                                        <td align='center'>{cellphoneMask(item.cellphone)}</td>
                                                        <td align='right' width={10}>
                                                            <div className='btn-group'>
                                                                <Tooltip title="Detalhes" placement="top">
                                                                    <button className='btn btn-primary text-white' onClick={(e) => this.showDetail(item)}>
                                                                        <i className="fas fa-eye" />
                                                                    </button>
                                                                </Tooltip>
                                                                <Tooltip title="Desativar" placement="top">
                                                                    <button className='btn btn-danger text-white' onClick={(e) => this.onRemove(item)}>
                                                                        <i className="fas fa-trash" />
                                                                    </button>
                                                                </Tooltip>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <Dialog onClose={this.hideNewCompanyModal} fullWidth maxWidth='md' open={this.state.isShowingNewCompanyModal}>
                    <MuiDialogTitle className='text-center'>
                        Cadastrar empresa
                    </MuiDialogTitle>
                    <MuiDialogContent>
                        <div className='row'>
                            <div className="col-lg-6">
                                <label>Razão social</label>
                                <input type="text" value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} className="form-control" />
                            </div>
                            <div className="col-lg-6">
                                <label>CNPJ</label>
                                <NumberFormat className="form-control" mask='_' format={'##.###.###/####-##'} value={this.state.document} onChange={(e) => this.setState({ document: e.target.value })} />
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className="col-lg-4">
                                <label>Representante</label>
                                <input type="text" value={this.state.representative} onChange={(e) => this.setState({ representative: e.target.value })} className="form-control" />
                            </div>
                            <div className="col-lg-4">
                                <label>Celular</label>
                                <NumberFormat className="form-control" mask='_' format={'(##)#####-####'} value={this.state.cellphone} onChange={(e) => this.setState({ cellphone: e.target.value })} />
                            </div>
                            <div className="col-lg-4">
                                <label>E-mail</label>
                                <input type="email" value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} className="form-control" />
                            </div>
                        </div>
                    </MuiDialogContent>
                    <MuiDialogActions>
                        <div className='btn-group m-3'>
                            <button onClick={this.hideNewCompanyModal} className='btn btn-secondary'>Fechar</button>
                            <button onClick={this.confirmNewCompany} className='btn btn-success'>Cadastrar e ver detalhes</button>
                        </div>
                    </MuiDialogActions>
                </Dialog>
            </div>
        )
    }
}

export { CompanyDetail, CompanyList };

